import { Modal } from "@mallardbay/lib-react-components"
import React from "react"

import COPY from "~config/copy-constants"
import type {
    ListingFieldsFragment,
    PublicListingFieldsFragment,
    UserFieldsFragment,
} from "~graphql/generated/graphql"
import RequestQuoteForm from "~components/shared/request-quote-modal/request-quote-form"

interface Props {
    readonly isOpen: boolean
    readonly onClose: () => void
    readonly listing: PublicListingFieldsFragment | ListingFieldsFragment
    readonly user?: UserFieldsFragment | null
    readonly trackingSource: string
    readonly trackingSourceUrl?: string
}

export default function RequestQuoteModal({
    isOpen,
    onClose,
    listing,
    user,
    trackingSource,
    trackingSourceUrl,
}: Props) {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={COPY.REQUEST_A_QUOTE}
            shouldAddPadding
        >
            <RequestQuoteForm
                outfitterId={listing.outfitter.id}
                listing={listing}
                user={user}
                onSuccess={onClose}
                trackingSource={trackingSource}
                trackingSourceUrl={trackingSourceUrl}
            />
        </Modal>
    )
}
